import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, toastSuccess, serviceTypeId } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { insertUpdateDayWiseProgram_action, getDayWiseProgramDetails_action } from "../../../../actions/admin_module_action/master_action/dayWiseProgram_action";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";

import TimePicker from "react-time-picker";


class DayWiseProgram extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            list: [{
                id: 1,
                Date: null,
                StartTime: null,
                EndTime: null,
                Title: null,
                Description: null,
                Speaker: null,
                Location: null,
            }],
            loginAccesslist: []
        }
    }

    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })

        this.getDayWiseProgramDetails()
    }

    getDayWiseProgramDetails() {
        this.setState({ isLoading: true })
        this.props.getDayWiseProgramDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    const res = data.data
                    if (res.length > 0) {
                        const map = res.map((item, i) => {
                            return {
                                id: i + 1,
                                Date: new Date(item.Date),
                                StartTime: item.StartTime ? moment.utc(item.StartTime).format('HH:mm') : null,
                                EndTime: item.EndTime ? moment.utc(item.EndTime).format('HH:mm') : null,
                                Title: item.Title,
                                Description: item.Description,
                                Speaker: item.Speaker,
                                Location: item.Location,
                            }
                        })
                        this.setState({ list: map })
                    }
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '63');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '63');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '63');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }


    onAddRow() {
        const { list } = this.state
        const isInvalid = list.some(item =>
            !item.Date ||
            !item.StartTime ||
            !item.Title?.trim() ||
            !item.Description?.trim() ||
            !item.Location?.trim()
        )

        if (isInvalid) {
            toastError("Please fill all mandatory fields")
            return
        }

        const id = list.length + 1
        const map = {
            id: id,
            Date: null,
            StartTime: null,
            EndTime: null,
            Title: null,
            Description: null,
            Speaker: null,
            Location: null,
        }
        list.push(map)
        this.setState({ list: list, })
    }


    insertUpdateDayWiseProgram() {
        const { list } = this.state

        const isInvalid = list.some(item =>
            !item.Date ||
            !item.StartTime ||
            !item.Title?.trim() ||
            !item.Description?.trim() ||
            !item.Location?.trim()
        )

        if (isInvalid) {
            toastError("Please fill all mandatory fields")
            return
        }

        this.setState({ isLoading: true })
        const array = []
        list.forEach(item => {
            const map = {
                DayWiseProgramID: 0,
                Date: item.Date != null ? moment(item.Date).format('YYYY-MM-DD') : '',
                StartTime: item.StartTime,
                EndTime: item.EndTime,
                Title: item.Title,
                Description: item.Description,
                Speaker: item.Speaker,
                Location: item.Location,
            }
            array.push(map)
        })
        this.props.insertUpdateDayWiseProgram_action(array)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    this.getDayWiseProgramDetails()
                    toastSuccess("Day wise program added successfully")
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDelete(id) {
        this.setState(prev => {
            const updatedlist = prev.list.filter(item => item.id !== id)
            return {
                list: updatedlist
            };
        }, () => {
            if (this.state.list.length == 0) {
                this.onAddRow();
            }
        });
    }

    handleInputChange = (value, index, field) => {
        const list = [...this.state.list];
        if (field === "Date") {
            list[index][field] = value;
        } else {
            list[index][field] = value.target.value;
        }
        this.setState({ list });
    };

    render() {
        const { isLoading, mainList, list, SDList, MainServiceID, IsActive } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {
                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                        <ExhibitorHeader /> : <HeaderWithLogo />
                }
                <div
                    //  className="with-dr-container com-height"
                    className={JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ? "with-dr-container" : "with-dr-container com-height"}
                >
                    <div className="main-container">
                        {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                                <ExhibitorDrawer /> : <AdminDrawer />
                        }
                        {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                                <ExhibitorTopMenu /> : null
                        }

                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Day Wise Program</h6>
                            </div>
                        </div>
                    </div>
                    <div className="admin-top-space p-2">
                        <div class="table-responsive px-1 sticky-table-wrapper service-list-grid">
                            <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th>Date <span className="text-danger">*</span></th>
                                        <th>Start Time <span className="text-danger">*</span></th>
                                        <th>End Time</th>
                                        <th>Title <span className="text-danger">*</span></th>
                                        <th>Description <span className="text-danger">*</span></th>
                                        <th>Speaker</th>
                                        <th>Location <span className="text-danger">*</span></th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        list.map((item, i) => (
                                            <tr>
                                                <td>
                                                    <DatePicker
                                                        style={{ zIndex: '99999' }}
                                                        selected={item.Date}
                                                        dateFormat={"dd/MM/yyyy"}
                                                        className="form-control"
                                                        onChange={(e) => this.handleInputChange(e, i, 'Date')}
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        placeholderText="DD/MM/YYYY"
                                                    />
                                                </td>
                                                <td>
                                                    <input type="time"
                                                        id="time1"
                                                        class="form-control"
                                                        value={item.StartTime}
                                                        onChange={(value) =>
                                                            this.handleInputChange(value, i, "StartTime")
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <input type="time"
                                                        id="time1"
                                                        class="form-control"
                                                        value={item.EndTime}
                                                        onChange={(value) =>
                                                            this.handleInputChange(value, i, "EndTime")
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" value={item.Title} onChange={(e) => this.handleInputChange(e, i, 'Title')} />
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" value={item.Description} onChange={(e) => this.handleInputChange(e, i, 'Description')} />
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" value={item.Speaker} onChange={(e) => this.handleInputChange(e, i, 'Speaker')} />
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" value={item.Location} onChange={(e) => this.handleInputChange(e, i, 'Location')} />
                                                </td>
                                                <td className="text-center">
                                                    <i className="fa fa-trash-o ms-2 grid-icon"
                                                        onClick={() => this.onDelete(item.id)}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                            <div style={{ float: 'left' }} className="mt-2">
                                <button type="button" class="btn btn-aqua rounded-0" onClick={(e) => this.onAddRow(e)}>
                                    Add +
                                </button>
                            </div>
                            <div style={{ float: 'right' }} >
                                <button disabled={list.length == 0 || !this.getWriteAccess()} type="button" class="btn btn-aqua rounded-1 mt-3 ms-2"
                                    // disabled={}
                                    onClick={(e) => this.insertUpdateDayWiseProgram(e)}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div >
                </div >
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, insertUpdateDayWiseProgram_action, getDayWiseProgramDetails_action })(DayWiseProgram));